<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden" style="height:100vh">

    <div v-if="ventaOk" class="alert alert-success mx-3 mt-2 mb-0 d-flex justify-content-between align-items-center fs-14 py-2">
      <span>✓ Venta registrada: <strong>{{ ventaOk }}</strong></span>
      <button class="btn-close btn-close-sm" @click="ventaOk = null"></button>
    </div>

    <div class="pos-layout flex-grow-1 overflow-hidden p-2 gap-2 d-flex">
      <!-- columna izquierda: búsqueda + carrito -->
      <PosCart
        :carrito="carrito"
        :idalmacen="idalmacen"
        style="flex:1; min-width:0"
        @agregar="agregarAlCarrito"
        @quitar="quitarDelCarrito"
        @limpiar="limpiarCarrito"
      />
      <!-- columna derecha: config + cobro -->
      <PosCobro
        :carrito="carrito"
        :series="series"
        :idalmacen="idalmacen"
        style="width:460px; flex-shrink:0; align-self:stretch"
        @limpiar="limpiarCarrito"
        @venta-registrada="onVentaRegistrada"
        @almacen-change="idalmacen = $event"
      />
    </div>

    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import MainHeader  from '../../components/Layouts/MainHeader.vue';
import MainSidebar from '../../components/Layouts/MainSidebar.vue';
import MainFooter  from '../../components/Layouts/MainFooter.vue';
import PosCart     from '../../components/Sales/Pos/PosCart.vue';
import PosCobro    from '../../components/Sales/Pos/PosCobro.vue';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const api = require('../../services/api').default;

interface CartItem {
  idpres: number; idprod: number; producto: string; presentacion: string;
  talla: string | null; precvta: number; precFinal: number; pctDsc: number; cantidad: number; stock: number;
}

export default defineComponent({
  name: 'PosPage',
  components: { MainHeader, MainSidebar, MainFooter, PosCart, PosCobro },
  setup() {
    const carrito   = ref<CartItem[]>([]);
    const series    = ref([]);
    const ventaOk   = ref<string | null>(null);
    const idalmacen = ref(1);

    onMounted(async () => {
      try { const res = await api.get('/ventas/series'); series.value = res.data.data || []; } catch { /* ok */ }
      const recrear = sessionStorage.getItem('pos_recrear');
      if (recrear) {
        try { const { items } = JSON.parse(recrear); items.forEach((i: any) => agregarAlCarrito(i)); } catch { /* ok */ }
        sessionStorage.removeItem('pos_recrear');
      }
    });

    function agregarAlCarrito(item: Omit<CartItem, 'precFinal' | 'pctDsc' | 'cantidad'>) {
      const ex = carrito.value.find(c => c.idpres === item.idpres);
      if (ex) { ex.cantidad += 1; }
      else { carrito.value.push({ ...item, precFinal: item.precvta, pctDsc: 0, cantidad: 1 }); }
    }
    function quitarDelCarrito(idx: number) { carrito.value.splice(idx, 1); }
    function limpiarCarrito() { carrito.value = []; }
    function onVentaRegistrada(data: { comprobante: string }) {
      ventaOk.value = data?.comprobante || 'OK';
      setTimeout(() => { ventaOk.value = null; }, 6000);
    }

    return { carrito, series, ventaOk, idalmacen, agregarAlCarrito, quitarDelCarrito, limpiarCarrito, onVentaRegistrada };
  },
});
</script>

<style scoped>
/* main-content tiene padding-top:140px del CSS global; el pos-layout ocupa el resto */
.pos-layout { height: calc(100vh - 155px); }
</style>
